import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=7f61428f&scoped=true&"
import script from "./WhatsNew.vue?vue&type=script&lang=ts&"
export * from "./WhatsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f61428f",
  null
  
)

export default component.exports